import * as React from "react";
import { useMemo } from "react";
import TableFetchContext from "./TableFetchContext";
const TableFetchContextProvider = ({
  children = void 0,
  searchParams,
  refetch,
  attributes,
  entityTableId
}) => {
  const contextValue = useMemo(
    () => ({
      searchParams,
      refetch,
      attributes,
      entityTableId
    }),
    [searchParams, refetch, attributes, entityTableId]
  );
  return /* @__PURE__ */ React.createElement(TableFetchContext.Provider, { value: contextValue }, children);
};
export default TableFetchContextProvider;
